(function () {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('Profile', Profile)
        .factory('CustomerStatusLogs', CustomerStatusLogs)
        .factory('ProfileChangePhone', ProfileChangePhone)
        .factory('ProfileIdByPhone', ProfileIdByPhone)
        .factory('CustomerTransferLimit', CustomerTransferLimit);

    Profile.$inject = ['$resource', 'DateUtils'];

    function Profile($resource, DateUtils) {
        var resourceUrl = 'api/profiles/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'queryByPhone': {method: 'GET', isArray: true, url: 'api/profiles/phone'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.registrationDate = DateUtils.convertDateTimeFromServer(data.registrationDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }

    CustomerStatusLogs.$inject = ['$resource'];

    function CustomerStatusLogs($resource) {
        var resourceUrl = 'api/customer-status-logs';
        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }

    ProfileChangePhone.$inject = ['$resource'];

    function ProfileChangePhone($resource) {
        var resourceUrl = 'api/customers/change-phone';
        return $resource(resourceUrl, {}, {
            'update': {method: 'PUT'}
        })

    }

    ProfileIdByPhone.$inject = ['$resource'];

    function ProfileIdByPhone ($resource) {
        var resourceUrl =  'api/profiles/id/phone/:phoneNumber';
        return $resource(resourceUrl, {}, {
            'get': { method: 'GET', isArray: false}
        });
    }

    CustomerTransferLimit.$inject = ['$resource'];

    function CustomerTransferLimit ($resource) {
        var resourceUrl =  'api/customers/:id/transfer-limit';
        return $resource(resourceUrl, {}, {
            'get': { method: 'GET'}
        });
    }

})();
